export const updateMemberCareerMutation = `
mutation updateUser ($careerIds: [Int], $userId: Int!){
  UpdateUserProfile(userData:{
    careerIds: $careerIds,
    userid: $userId
  }){
    user{
      careers{
        id
        userId
        careerId
          career{
          name
        }
      }
    }
  }
}
`;
